module.exports = __webpack_public_path__ + "img/v3-member.cdc52c0c.png";